import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { DataService } from "src/app/services/data.service";
import { UrlService } from "../../../../miscellaneous/url.service";
import { SafeHtml, DomSanitizer } from "@angular/platform-browser";
import { environment } from "src/environments/environment";
import { Router } from '@angular/router';
import { BreadcrumbTitleService } from 'src/app/services/breadcrumb-title.service';

@Component({
  selector: "hero",
  templateUrl: "./hero.component.html",
  styleUrls: ["./hero.component.scss"],
})
export class HeroComponent implements OnInit {

  data!: any;
  model!: any;

  safeHtml: SafeHtml = '';

constructor(
  private dataService: DataService,
  private urlService: UrlService,
  private cdr: ChangeDetectorRef,
  private sanitizer: DomSanitizer,
  private breadcrumbTitleService: BreadcrumbTitleService,
  private router: Router
) {}

  ngOnInit(): void {
    const pathAtLoad = this.router.url.split(/[?#]/)[0];
    const id = this.urlService.getUrlId();

    if (!id) return;

    this.dataService.getData(`${this.data.endpoint}/${id}`)
      .subscribe(model => {

        const applyModel = (finalModel: any) => {
          this.model = finalModel;

          // Pubblica il nome da mostrare nel breadcrumb.
          this.publishBreadcrumbLabel(
            finalModel,
            pathAtLoad,
            String(id)
          );

          if (this.data.template) {
            const rawHtml = this.generateHtml(
              this.data.template,
              this.model
            );

            this.safeHtml =
              this.sanitizer.bypassSecurityTrustHtml(rawHtml);
          }

          this.cdr.detectChanges();
        };

        if (this.data.entityType) {
          const lastDateUrl =
            `${environment.api_base_url}/${environment.endpointLastDate}` +
            `/${id}/?entityType=${this.data.entityType}`;

          this.dataService.getData(lastDateUrl)
            .subscribe((response: any) => {
              const finalModel = { ...model };
              finalModel.updatedAt = response?.updatedAt;
              applyModel(finalModel);
            });
        } else {
          applyModel(model);
        }
      });
  }

  generateHtml(template: string, model: any): string {

    const isEmptyValue = (value: string): boolean => {
      const emptyValues = ['N/D', undefined, "undefined", null, "null"];
      return emptyValues.includes(value);
    };

    return template
      .split('\n')
      .map(line => {
        line = line.replace(/\{\{(.*?)\}\}/g, (_, key) => {
          const trimmedKey = key.trim();
          let value = model[trimmedKey] ?? (this.data?.defaultValue as any)?.[trimmedKey] ?? 'N/D';
          return this.formatValue(value);
        });
        return line.replace(/<a href="(mailto|tel):.*?">(.*?)<\/a>/g, (_, type, content) => {
          console.log(content);
          const value = content;
          if (isEmptyValue(value)) {
            return `<span>${content}</span>`;
          }
          return `<a href="${type}:${content}">${content}</a>`;
        });
      })
      .join('\n');
  }
  
  private formatValue(value: any): any {
    if (value === true) return 'SI';
    if (value === false) return 'NO';
    return value || '';
  }
  
  private publishBreadcrumbLabel(model: any, pathAtLoad: string, id: string ): void {  
    const fieldPath = this.data?.breadcrumbLabelField;

    // Il comportamento è attivo solo per i widget configurati.
    if (typeof fieldPath !== 'string' || !fieldPath.trim()) {
      return;
    }

    // Supporta anche proprietà annidate, ad esempio employee.nomeCompleto.
    const label = fieldPath
      .split('.')
      .reduce(
        (value: any, key: string) => value?.[key],
        model
      );

    if (label === null || label === undefined) {
      return;
    }

    const title = String(label).trim();

    if (!title) {
      return;
    }

    this.breadcrumbTitleService.setTitle({
      path: pathAtLoad,
      id,
      title
    });
  }

}

